import React from "react";
import { errorMessage } from "Utils/useRequest";
import style from "./index.module.scss";
import { ResultMessage } from "components/ResultMessage";
import { stuCourseJoinInByCode } from "API/invitationCode";

interface ConfirmModalProps {
    onCancel: () => void;
    onOk: () => void;
    courseInfo: {
        batchNo: string;
        courseNo: string;
        courseSeq: string;
        courseId: string;
        courseName: string;
        teacherName: string;
    };
    code: string;
}

export default function ConfirmModal({
    onCancel,
    onOk,
    courseInfo,
    code
}: ConfirmModalProps) {
    const handleAdd = async function () {
        try {
            await stuCourseJoinInByCode(code);
            ResultMessage.success("成功加入课程");
            onOk();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    return (
        <div className={style.root}>
            <div className={style.container}>
                <div className={style.top}>
                    <div className={style.title}>确认加入课程？</div>
                    <div className={style.info}>
                        <div>课程名称：{courseInfo.courseName}</div>
                        <div>授课教师：{courseInfo.teacherName}</div>
                    </div>
                </div>

                <div className={style.footer}>
                    <div onClick={onCancel}>不加入</div>
                    <div onClick={handleAdd}>确认加入</div>
                </div>
            </div>
        </div>
    );
}
